export const PageHeader = ({ eyebrow, h1, intro }) => (
  <section className="pt-32 md:pt-40 pb-6 px-6 md:px-12" data-testid="page-header">
    <div className="max-w-[1400px] mx-auto text-center">
      {eyebrow && <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-5">{eyebrow}</p>}
      <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight max-w-4xl mx-auto">
        {h1}
      </h1>
      {intro && <p className="mt-6 max-w-3xl mx-auto text-foreground/75 font-light leading-relaxed">{intro}</p>}
    </div>
  </section>
);
